// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeaturedDestinationSection_section__AegA5 {
  width: 100%;
  box-sizing: border-box;
  /* Same break as Explore What's Trending: its 16px bottom margin, without stacking another top margin. */
  margin: 0 0 16px;
  padding: 16px;
}

.FeaturedDestinationSection_panel__YEBcq {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.FeaturedDestinationSection_header__PF\\+Ty {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.FeaturedDestinationSection_copy__-QPdu {
  min-width: 0;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.FeaturedDestinationSection_titleRow__rUCPA {
  display: flex;
  align-items: center;
  gap: 10px;
}

.FeaturedDestinationSection_titleIcon__lRpcN {
  flex-shrink: 0;
}

.FeaturedDestinationSection_title__hYqMT {
  margin: 0;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 34px;
  font-weight: 750;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.FeaturedDestinationSection_description__k-Mub {
  margin: 0;
  color: #6b7280;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
}

.FeaturedDestinationSection_controls__I7juZ {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  padding-bottom: 4px;
}

.FeaturedDestinationSection_counter__gVPiu {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.FeaturedDestinationSection_counterTrack__7oKmQ {
  width: 42px;
  height: 3px;
  border-radius: 999px;
  background: #d7dde6;
  position: relative;
  overflow: hidden;
}

.FeaturedDestinationSection_counterFill__NwoYz {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: #1493d4;
  border-radius: inherit;
}

.FeaturedDestinationSection_arrow__uEPjy {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e4e7ee;
  background: #fff;
  color: #121826;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.FeaturedDestinationSection_arrow__uEPjy:disabled {
  color: #c5cad3;
  cursor: not-allowed;
}

.FeaturedDestinationSection_scroller__N-xcD {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: clip;
  overscroll-behavior-x: contain;
  overscroll-behavior-y: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x pan-y;
  scrollbar-width: none;
}

.FeaturedDestinationSection_scroller__N-xcD::-webkit-scrollbar {
  display: none;
}

.FeaturedDestinationSection_card__4kRmG {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 48px) / 4);
  flex-direction: column;
  scroll-snap-align: start;
  background: #fff;
  border-radius: 18px;
  overflow: clip;
  border: 1px solid #eef0f4;
  text-align: left;
  padding: 0;
  cursor: pointer;
  min-width: 0;
}

.FeaturedDestinationSection_media__Ubolh {
  position: relative;
  height: 168px;
  background: #e8e9ed;
}

.FeaturedDestinationSection_media__Ubolh img,
.FeaturedDestinationSection_media__Ubolh > div {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.FeaturedDestinationSection_body__9-IVt {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 14px 8px;
}

.FeaturedDestinationSection_location__JQeBs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 12px;
}

.FeaturedDestinationSection_cardTitle__xt2tw {
  margin: 0;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.FeaturedDestinationSection_cardDescription__ZVJ7W {
  margin: 0;
  color: #6b7280;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 13px;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.FeaturedDestinationSection_footer__F6Dpr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 14px 14px;
}

.FeaturedDestinationSection_bestTime__0bIGQ {
  color: #6b7280;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 12px;
}

.FeaturedDestinationSection_explore__\\+WSID {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: #121826;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.FeaturedDestinationSection_shimmerCopy__ErZCG {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.FeaturedDestinationSection_shimmerCard__epcLP {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 48px) / 4);
  flex-direction: column;
  gap: 10px;
  padding: 0 0 14px;
  background: #fff;
  border-radius: 18px;
  overflow: clip;
  border: 1px solid #eef0f4;
}

@media (min-width: 900px) {
  .FeaturedDestinationSection_section__AegA5 {
    padding: 24px clamp(20px, 1.25vw, 40px);
  }

  .FeaturedDestinationSection_panel__YEBcq {
    max-width: 1200px;
    gap: 16px;
  }
}

@media (min-width: 1200px) {
  .FeaturedDestinationSection_section__AegA5 {
    padding: 28px clamp(24px, 1.25vw, 48px);
  }

  .FeaturedDestinationSection_panel__YEBcq {
    max-width: 1400px;
    gap: 18px;
  }
}

@media (min-width: 1536px) {
  .FeaturedDestinationSection_section__AegA5 {
    padding: 32px clamp(24px, 1.25vw, 48px);
  }

  .FeaturedDestinationSection_panel__YEBcq {
    max-width: 1600px;
    gap: 20px;
  }
}

@media (max-width: 1100px) {
  .FeaturedDestinationSection_card__4kRmG,
  .FeaturedDestinationSection_shimmerCard__epcLP {
    flex-basis: calc((100% - 16px) / 2);
  }

  .FeaturedDestinationSection_title__hYqMT {
    font-size: 28px;
  }
}

@media (max-width: 700px) {
  .FeaturedDestinationSection_header__PF\\+Ty {
    flex-direction: column;
    align-items: flex-start;
  }

  .FeaturedDestinationSection_controls__I7juZ {
    display: none;
  }

  .FeaturedDestinationSection_card__4kRmG,
  .FeaturedDestinationSection_shimmerCard__epcLP {
    flex-basis: 78%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/FeaturedDestinationSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,wGAAwG;EACxG,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  width: 100%;\n  box-sizing: border-box;\n  /* Same break as Explore What's Trending: its 16px bottom margin, without stacking another top margin. */\n  margin: 0 0 16px;\n  padding: 16px;\n}\n\n.panel {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.copy {\n  min-width: 0;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.titleIcon {\n  flex-shrink: 0;\n}\n\n.title {\n  margin: 0;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 34px;\n  font-weight: 750;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n}\n\n.description {\n  margin: 0;\n  color: #6b7280;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n  padding-bottom: 4px;\n}\n\n.counter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.counterTrack {\n  width: 42px;\n  height: 3px;\n  border-radius: 999px;\n  background: #d7dde6;\n  position: relative;\n  overflow: hidden;\n}\n\n.counterFill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  background: #1493d4;\n  border-radius: inherit;\n}\n\n.arrow {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #e4e7ee;\n  background: #fff;\n  color: #121826;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.arrow:disabled {\n  color: #c5cad3;\n  cursor: not-allowed;\n}\n\n.scroller {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 16px;\n  width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: clip;\n  overscroll-behavior-x: contain;\n  overscroll-behavior-y: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-x pan-y;\n  scrollbar-width: none;\n}\n\n.scroller::-webkit-scrollbar {\n  display: none;\n}\n\n.card {\n  display: flex;\n  flex: 0 0 calc((100% - 48px) / 4);\n  flex-direction: column;\n  scroll-snap-align: start;\n  background: #fff;\n  border-radius: 18px;\n  overflow: clip;\n  border: 1px solid #eef0f4;\n  text-align: left;\n  padding: 0;\n  cursor: pointer;\n  min-width: 0;\n}\n\n.media {\n  position: relative;\n  height: 168px;\n  background: #e8e9ed;\n}\n\n.media img,\n.media > div {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 14px 8px;\n}\n\n.location {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #6b7280;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 12px;\n}\n\n.cardTitle {\n  margin: 0;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.cardDescription {\n  margin: 0;\n  color: #6b7280;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 13px;\n  line-height: 1.45;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 14px 14px;\n}\n\n.bestTime {\n  color: #6b7280;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 12px;\n}\n\n.explore {\n  margin-left: auto;\n  border: 0;\n  background: transparent;\n  color: #121826;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n}\n\n.shimmerCopy {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.shimmerCard {\n  display: flex;\n  flex: 0 0 calc((100% - 48px) / 4);\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 0 14px;\n  background: #fff;\n  border-radius: 18px;\n  overflow: clip;\n  border: 1px solid #eef0f4;\n}\n\n@media (min-width: 900px) {\n  .section {\n    padding: 24px clamp(20px, 1.25vw, 40px);\n  }\n\n  .panel {\n    max-width: 1200px;\n    gap: 16px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .section {\n    padding: 28px clamp(24px, 1.25vw, 48px);\n  }\n\n  .panel {\n    max-width: 1400px;\n    gap: 18px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .section {\n    padding: 32px clamp(24px, 1.25vw, 48px);\n  }\n\n  .panel {\n    max-width: 1600px;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .card,\n  .shimmerCard {\n    flex-basis: calc((100% - 16px) / 2);\n  }\n\n  .title {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 700px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .controls {\n    display: none;\n  }\n\n  .card,\n  .shimmerCard {\n    flex-basis: 78%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `FeaturedDestinationSection_section__AegA5`,
	"panel": `FeaturedDestinationSection_panel__YEBcq`,
	"header": `FeaturedDestinationSection_header__PF+Ty`,
	"copy": `FeaturedDestinationSection_copy__-QPdu`,
	"titleRow": `FeaturedDestinationSection_titleRow__rUCPA`,
	"titleIcon": `FeaturedDestinationSection_titleIcon__lRpcN`,
	"title": `FeaturedDestinationSection_title__hYqMT`,
	"description": `FeaturedDestinationSection_description__k-Mub`,
	"controls": `FeaturedDestinationSection_controls__I7juZ`,
	"counter": `FeaturedDestinationSection_counter__gVPiu`,
	"counterTrack": `FeaturedDestinationSection_counterTrack__7oKmQ`,
	"counterFill": `FeaturedDestinationSection_counterFill__NwoYz`,
	"arrow": `FeaturedDestinationSection_arrow__uEPjy`,
	"scroller": `FeaturedDestinationSection_scroller__N-xcD`,
	"card": `FeaturedDestinationSection_card__4kRmG`,
	"media": `FeaturedDestinationSection_media__Ubolh`,
	"body": `FeaturedDestinationSection_body__9-IVt`,
	"location": `FeaturedDestinationSection_location__JQeBs`,
	"cardTitle": `FeaturedDestinationSection_cardTitle__xt2tw`,
	"cardDescription": `FeaturedDestinationSection_cardDescription__ZVJ7W`,
	"footer": `FeaturedDestinationSection_footer__F6Dpr`,
	"bestTime": `FeaturedDestinationSection_bestTime__0bIGQ`,
	"explore": `FeaturedDestinationSection_explore__+WSID`,
	"shimmerCopy": `FeaturedDestinationSection_shimmerCopy__ErZCG`,
	"shimmerCard": `FeaturedDestinationSection_shimmerCard__epcLP`
};
export default ___CSS_LOADER_EXPORT___;
